import { createDelayedRegistrationHook } from "../utils/delayedRegistrationHook.js";
import type { AssetIdentity } from "./assetIdentity.js";

export type AssetIdentitySyncPayload = Pick<AssetIdentity, "loraEui" | "assetCollection" | "assetType" | "verdiId">;

/**
 * Delayed-registration hook fired when an asset identity is created or updated.
 *
 * Should be passed more or less the complete asset identity to be registered. Generating the
 * appropriate verdi ID is the callers responsibility
 *
 * This action implements database propagation and cache invalidation.
 * */
export const assetIdentitySync =
    createDelayedRegistrationHook<(payload: AssetIdentitySyncPayload) => Promise<void>>("assetIdentitySync");
